<template>
    <div>
        <el-scrollbar style="height:100% ;overflow-x:hidden">
            <el-card style="margin: 0 0 50px 0;height: 100%;">
                <div>
                    <el-button style="" @click="goBack">返回</el-button>
                </div>
                <div>


                    <div style="height: 590px; width: 76%;position: relative;margin-left: 12%;">
                        <!-- <iframe id="myFrameId" name="ifrmName" :src="iframeUrl" width="100%" height="700px"></iframe> -->
                        <!-- <largeScreen1 style="height:100%;width: 100%;" /> -->
                        <homeView :shouyeBackdropImage="shouyeBackdropImage" :shouyeIcon="tableData"></homeView>

                    </div>
                </div>

                <div style="margin: 1% 0;" class="zhoumian">
                    <span>桌面背景上传：</span>

                    <!-- <el-upload class="demo" :action="fileUrl" accept="image/*" list-type="picture-card" :on-success="handleSuccess"
                  :before-upload="beforeAvatarUpload" :before-remove="() => false" :file-list="formInline.homeMapImage"
                  :headers="{ Authorization: token }">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{ file }">
                    <img class="el-upload-list__item-thumbnail" :src="urlprefix + file.url" alt="" />
                    <el-input style="width: 100%; margin-top: 1%" v-model="file.name" placeholder="图片说明" clearable>
                    </el-input>
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span class="el-upload-list__item-delete" @click="handleRemove(file, formInline.homeMapImage)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload> -->

                    <el-upload :show-file-list="true" :action="fileUrl1" accept="image/*" list-type="picture-card"
                        style="display: inline-block;" :limit="5" :on-success="handleSuccess"
                        :before-upload="beforeAvatarUpload" :before-remove="() => false" :file-list="shouyeBackdropImage"
                        :headers="{ Authorization: token }">
                        <i slot="default" class="el-icon-plus"></i>

                        <div slot="file" slot-scope="{file}" style="width: 148px;height: 148px;">

                            <img class="el-upload-list__item-thumbnail" :src=" file.url" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                    <i class="el-icon-download"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete"
                                    @click="handleRemove(file, shouyeBackdropImage)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>

                    </el-upload>
                    <div style="color: #929292;margin-top: 3px;">注：只上传格式为 jpg / png 文件，图片最少上传1张，多上传5张。<span style="color: red;">为了在大屏展示更好效果，建议尺寸为1280*720，或同比例放大缩小</span></div>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>

                </div>

                <div>
                    <el-table :key="iconKey" :data="tableData" :header-cell-style="{ background: '#fff', color: '#000' }"
                        border style="width: 100%">
                        <el-table-column prop="name" label="名称">
                        </el-table-column>
                        <el-table-column prop="icon" label="图标">
                            <template slot-scope="scope" >
                                <div style="background-color: #1296db;">
                                    <el-image style="height: 30px;width: 30px;" v-if="scope.row.icon"
                                    :src="scope.row.icon">
                                </el-image>
                                <el-image style="height: 30px;width: 30px;" v-else>
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>

                                </div>
                                
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="是否展示">
                            <template slot-scope="scope">
                                <el-switch @change="switchChange(scope.$index, scope.row)" v-model="scope.row.status"
                                    active-color="#1890ff" inactive-color="#eaecf0" :active-value="1" :inactive-value="0">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="操作">
                            <template slot-scope="scope">
                                <div style="color: #1296db;font-weight: 800;font-size: 1vw;">
                                    <i class="el-icon-top" @click="clickTop(scope.$index)" v-if="scope.$index != 0"
                                        style="margin-right: 1%;"></i>
                                    <i class="el-icon-bottom" @click="clickBottom(scope.$index)"
                                        v-if="scope.$index != tableData.length - 1" style="margin-right: 1%;"></i>
                                    <!-- <i class="el-icon-edit" @click="openDig(scope.row, scope.$index)"
                                        v-if="scope.row.type == 'costom'" style="margin-right: 1%;"></i> -->
                                        <i class="el-icon-edit" @click="openDig(scope.row, scope.$index)"
                                         style="margin-right: 1%;"></i>
                                    <i class="el-icon-s-tools" @click="skipSetting(scope.row)" v-if="scope.row.type == 'system' && scope.row.url!='/prevention-screen/'"
                                        style="margin-right: 1%;"></i>
                                </div>

                            </template>
                        </el-table-column>
                    </el-table>

                    <el-dialog title="编辑" :visible.sync="iconDialogVisible" width="30%" :before-close="handleClose">
                        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                            <el-form-item label="名称" prop="name" :rules="[
                                { required: true, message: '名称不能为空', trigger: 'blur' },
                            ]">
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item>
                            <el-form-item label="链接" prop="url">
                                <el-input v-model="ruleForm.url" :disabled="ruleForm.type=='system'"></el-input>
                            </el-form-item>
                            <el-form-item label="是否显示" prop="status" :rules="[
                                { required: true, message: '请选择是否显示', trigger: 'change' }
                            ]">
                                <el-select v-model="ruleForm.status" placeholder="请选择是否显示">
                                    <el-option label="是" :value="1"></el-option>
                                    <el-option label="否" :value="0"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="图标" class="SeedlingsImg">
                                <el-upload v-if="!dataStatus" ref="uploadImg" class="seedlings-avatar-uploader radius_4"
                                    :action="fileUrl" name="file" :multiple="false" :limit="1" :show-file-list="false"
                                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                                    :headers="{ Authorization: token }">
                                    <i style="border: 1px dashed #d9d9d9"
                                        class="el-icon-plus seedlings-avatar-uploader-icon icon"></i>
                                        <span style="color: red;font-size: 0.5vw;">为了在大屏展示更好效果，建议尺寸为58*58，或同比例放大缩小</span>
                                </el-upload>
                                <div v-if="dataStatus" style="width: 102px; height: 102px; position: relative">
                                    <span class="aaa">
                                        <i v-if="dataStatus" class="el-icon-delete" style="" @click="delPreviewImg"></i>

                                    </span>

                                    <img preview="222" style="background-color: rebeccapurple;" class="iconImage" v-if="imageUrl" :src=" imageUrl" />
                                </div>
                            </el-form-item>

                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="iconDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="saveIcon">确 定</el-button>
                        </span>
                    </el-dialog>
                </div>




            </el-card>

        </el-scrollbar>
    </div>
</template>
  
<script>

import * as api from "@/api/large-screen";
import * as user from "@/api/user";

import CFG from "@/config/config";

import largeScreen from "@/pages/large-screen/index.vue";
import largeScreen1 from "@/pages/large-screen/index-view.vue";
import homeView from "@/pages/large-screen/components/home-view.vue";
import axios from 'axios'
import * as cloudScreenApi from "@/api/cloud-screen";
export default {
    name: "terminal-configuration",
    components: { largeScreen, largeScreen1, homeView },
    data() {
        return {
            urlprefix: CFG.LOTIP,
            token: "Bearer" + " " + this.$store.state.token,
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            tableData: [],
            organization: {},
            temp: null,
            device: null,
            fileUrl: CFG.LOTIP + "/file/uploadFile?url=icon", //图片文件上传地址,
            fileUrl1: CFG.LOTIP + "/file/uploadFile?url=zhuomian", //图片文件上传地址,
            shouyeBackdropImage: [],

            iframeUrl: '',
            iconDialogVisible: false,
            ruleForm: {},
            dataStatus: false,
            iconIndex: null,
            iconKey: Math.random(),

            device: null,

        };
    },

    methods: {
        skipSetting(row) {
            if (row.type=='system') {
                if (row.url=='/large-screen/') {
                    this.$router.push('/setting-page/' + this.device.id)
                }
                // if (row.url=='/prevention-screen/') {
                //     this.$router.push('/setting-page/' + this.device.id)
                // }
                if (row.url=='/atlas_view/') {
                    this.$router.push('/atlas-setting/' + this.device.systemSid)
                }
                if (row.url=='/website_view/') {
                    this.$router.push('/website-setting/' + this.device.systemSid)
                }
                
            }
            
        },
        saveIcon() {


            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {



                    let obj = null
                    if (this.temp) {
                        obj = this.temp
                    } else {
                        obj = {
                            templateType: 1,
                            systemSid: this.$route.params.systemSid
                        }
                    }

                    this.tableData[this.iconIndex] = JSON.parse(JSON.stringify(this.ruleForm))
                    obj['shouyeIcon'] = JSON.stringify(this.tableData)

                    api.updateTemplate(obj).then(res => {
                        if (res.resp_code == "10000") {

                            this.handleClose()
                            this.getTemp1()
                        }
                    });




                    // this.iconKey = Math.random()

                }
            });



        },
        delPreviewImg() {
            this.imageUrl = "";
            this.ruleForm.img = "";
            this.dataStatus = false;
            this.ruleForm.icon = ''
        },
        handleAvatarSuccess(res, file) {
            //上传照片
            this.dataStatus = true;
            this.$refs.uploadImg.clearFiles();
            console.log(res, "aaaaaaa");
            this.ruleForm.icon = res.data.url;
            this.imageUrl = res.data.url;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg" || "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },
        sortKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return ((x < y) ? -1 : (x > y) ? 1 : 0)
            })
        },
        handleClose() {
            this.iconDialogVisible = false

            this.imageUrl = "";
            this.ruleForm = {};
            this.dataStatus = false;

            this.iconIndex = null



        },
        openDig(row, index) {
            this.iconDialogVisible = true
            let obj = JSON.parse(JSON.stringify(row))
            this.ruleForm = obj
            this.iconIndex = index

            this.imageUrl = obj.icon;
            this.ruleForm.img = obj.icon;
            if (this.imageUrl) {
                this.dataStatus = true;
            } else {
                this.dataStatus = false;
            }


        },
        clickTop(index) {
            let one = this.tableData[index - 1].sort
            let two = this.tableData[index].sort
            this.tableData[index - 1].sort = two
            this.tableData[index].sort = one
            // this.tableData = this.sortKey(this.tableData, 'sort')

            let obj = null
            if (this.temp) {
                obj = this.temp
            } else {
                obj = {
                    templateType: 1,
                    systemSid: this.$route.params.systemSid
                }
            }


            obj['shouyeIcon'] = JSON.stringify(this.tableData)

            api.updateTemplate(obj).then(res => {
                if (res.resp_code == "10000") {

                    this.getTemp1()
                }
            });

        },
        clickBottom(index) {
            let one = this.tableData[index].sort
            let two = this.tableData[index + 1].sort
            this.tableData[index].sort = two
            this.tableData[index + 1].sort = one
            // this.tableData = this.sortKey(this.tableData, 'sort')

            let obj = null
            if (this.temp) {
                obj = this.temp
            } else {
                obj = {
                    templateType: 1,
                    systemSid: this.$route.params.systemSid
                }
            }


            obj['shouyeIcon'] = JSON.stringify(this.tableData)

            api.updateTemplate(obj).then(res => {
                if (res.resp_code == "10000") {

                    this.getTemp1()
                }
            });

        },
        getUrl(systemSid) {
            this.iframeUrl = window.location.protocol + "//" + window.location.host + "/#/cloud_screen/" + systemSid
        },
        //（文件上传成功时的钩子）
        handleSuccess(res, file, fileList) {
            console.log(res, file, fileList);
            if (res.resp_code == "10000") {



                let arr = JSON.parse(JSON.stringify(this.shouyeBackdropImage))
                arr.push(res.data)
                this.shouyeBackdropImage = arr

                var uploader = this.$el.querySelectorAll('.zhoumian .el-upload.el-upload--picture-card')[0];
                if (!uploader) {
                    return;
                }
                if (this.shouyeBackdropImage.length >= 5) {
                    uploader.classList.add('hidden');
                } else {
                    uploader.classList.remove('hidden');
                }

                let obj = null
                if (this.temp) {
                    obj = this.temp
                } else {
                    obj = {
                        templateType: 1,
                        systemSid: this.$route.params.systemSid
                    }
                }


                obj['shouyeBackdropImage'] = JSON.stringify(this.shouyeBackdropImage)

                api.updateTemplate(obj).then(res => {
                    if (res.resp_code == "10000") {

                        // this.getTemp()
                    }
                });
            }
        },
        beforeAvatarUpload(file) {
            // const isJPG = ["image/jpg", "image/jpeg", "image/png"].includes(file.type);
            const isLt5M = file.size / 1024 / 1024 < 10;
            // if (!isJPG) {
            //   this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            // }
            if (!isLt5M) {
                this.$message.error("上传头像图片大小不能超过 10MB!");
            }
            return isLt5M;
        },
        switchChange(index, row) {
            console.log(index, row);
            let obj = null
            if (this.temp) {
                obj = this.temp
            } else {
                obj = {
                    templateType: 1,
                    systemSid: this.$route.params.systemSid
                }
            }


            obj['shouyeIcon'] = JSON.stringify(this.tableData)

            api.updateTemplate(obj).then(res => {
                if (res.resp_code == "10000") {


                    this.getTemp1()
                }
            });


        },
        pageSetting(row, index) {
            console.log(row, index)
            if (index == 0) {
                this.$router.push("/home-setting/" + this.$route.params.id);

            } else if (index == 1) {
                this.$router.push('/resource-setting/' + this.$route.params.id)
            } else if (index == 2) {
                this.$router.push('/ecological-condition-setting/' + this.$route.params.id)
            } else if (index == 3) {
                this.$router.push('/pest-status-setting/' + this.$route.params.id)
            }

        },
        goBack() {
            window.history.back();

        },
        reload() {
            // document.frames('ifrmName').location.reload()
            const el = document.querySelector('#myFrameId')
            const tmpUrl = el.src
            el.src = 'about:blank' // 作为一个临时的链接，如果是其它正常可访问URL，会浪费一些不必要流量
            const _t = setTimeout(() => {
                el.src = tmpUrl
                clearTimeout(_t)
            }, 300) // 太短，iframe依然反应不过来，太长效果又不好，300ms刚刚好

        },
        handleRemove(file, shouyeBackdropImage) {
            console.log(file)

            this.shouyeBackdropImage = shouyeBackdropImage.filter((item) => {
                return item.uid !== file.uid;
            });
            var uploader = this.$el.querySelectorAll('.zhoumian .el-upload.el-upload--picture-card')[0];
            if (!uploader) {
                return;
            }
            if (this.shouyeBackdropImage.length >= 5) {
                uploader.classList.add('hidden');
            } else {
                uploader.classList.remove('hidden');
            }

            api.deleteFileByUrl(file.url).then(res => {
                if (res.resp_code == "10000") {
                    let obj = null
                    if (this.temp) {
                        obj = this.temp
                    } else {
                        obj = {
                            templateType: 1,
                            systemSid: this.$route.params.systemSid
                        }
                    }
                    obj['shouyeBackdropImage'] = JSON.stringify(this.shouyeBackdropImage)
                    api.updateTemplate(obj).then(res => {
                        if (res.resp_code == "10000") {

                            // this.getTemp()
                        }
                    });
                }
            })




        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl =  file.url;
            this.dialogVisible = true;
        },
        // imgUrl为图片路径，fileName为文件名
        async handleDownload(file) {
            const imageUrl =  file.url
            let arr = imageUrl.split("/")
            let name = arr[arr.length - 1]
            const url = await this.getImgArrayBuffer(imageUrl)
            const objectUrl = URL.createObjectURL(url);
            var a = document.createElement("a"); // 生成一个a元素
            var event = new MouseEvent("click"); // 创建一个单击事件
            a.download = name || "photo"; // 设置图片名称
            a.href = objectUrl; // 将生成的URL设置为a.href属性
            a.dispatchEvent(event); // 触发a的单击事件

        },
        //获取文件blob
        getImgArrayBuffer(url) {
            let _this = this;
            return new Promise((resolve, reject) => {
                //通过请求获取文件blob格式
                let xmlhttp = new XMLHttpRequest();
                xmlhttp.open("GET", url, true);
                xmlhttp.responseType = "blob";
                xmlhttp.onload = function () {
                    if (this.status == 200) {
                        resolve(this.response);
                    } else {
                        reject(this.status);
                    }
                };
                xmlhttp.send();
            });
        },

        handleDownload1(file) {

            console.log(file);
        },
        getTemp() {
            this.shouyeBackdropImage = []

            api.getDeviceTempBySystemSid(this.$route.params.systemSid).then(res => {
                if (res.resp_code == "10000") {
                    console.log(res.data, "==================")
                    this.device = res.data
                    let arr = []
                    let obj1 = { name: "草原一张图", url:  "/large-screen/" , status: 0, icon: '/large-screen/icon/cy.png', sort: 1, type: 'system' }
                    let obj7 = { name: "防治一张图", url:  "/prevention-screen/" , status: 0, icon: '/large-screen/icon/cy.png', sort: 1, type: 'system' }
                    let obj2 = { name: "生物建模", url: '/atlas_view/', status: 0, icon: '/large-screen/icon/jm.png', sort: 2, type: 'system' }
                    let obj6 = { name: "企业官网", url: '/website_view/', status: 0, icon: '/large-screen/icon/gw.png', sort: 3, type: 'system' }
                    let obj3 = { name: "自定义", url: '', status: 0, icon: '', sort: 4, type: 'costom' }
                    let obj4 = { name: "自定义", url: '', status: 0, icon: '', sort: 5, type: 'costom' }
                    let obj5 = { name: "自定义", url: '', status: 0, icon: '', sort: 6, type: 'costom' }
                    if (res.data) {
                        this.temp = res.data.temp
                        if (this.temp) {
                            if (this.temp.shouyeIcon) {
                                arr = JSON.parse(this.temp.shouyeIcon)
                            } else {
                                arr.push(obj1)
                                arr.push(obj7)
                                arr.push(obj2)
                                arr.push(obj6)
                                arr.push(obj3)
                                arr.push(obj4)
                                arr.push(obj5)
                            }
                            if (this.temp.shouyeBackdropImage) {
                                this.shouyeBackdropImage = JSON.parse(this.temp.shouyeBackdropImage)
                            } else {
                                this.shouyeBackdropImage = []
                            }
                        } else {
                            arr.push(obj1)
                            arr.push(obj7)
                            arr.push(obj2)
                            arr.push(obj6)
                            arr.push(obj3)
                            arr.push(obj4)
                            arr.push(obj5)
                            this.shouyeBackdropImage = []
                        }
                        var uploader = this.$el.querySelectorAll('.zhoumian .el-upload.el-upload--picture-card')[0];
                        if (!uploader) {
                            return;
                        }
                        if (this.shouyeBackdropImage.length >= 5) {
                            uploader.classList.add('hidden');
                        } else {
                            uploader.classList.remove('hidden');
                        }
                    } else {
                        arr.push(obj1)
                        arr.push(obj7)
                        arr.push(obj2)
                        arr.push(obj6)
                        arr.push(obj3)
                        arr.push(obj4)
                        arr.push(obj5)
                        this.shouyeBackdropImage = []
                    }
                    this.tableData = this.sortKey(arr, 'sort')
                    
                }
            });
        },
        getTemp1() {
            api.getDeviceTempBySystemSid(this.$route.params.systemSid).then(res => {
                if (res.resp_code == "10000") {
                    console.log(res.data, "==================")
                    this.device = res.data
                    let arr = []
                    let obj1 = { name: "草原一张图", url:  "/large-screen/" , status: 0, icon: '/large-screen/icon/cy.png', sort: 1, type: 'system' }
                    let obj7 = { name: "防治一张图", url:  "/prevention-screen/" , status: 0, icon: '/large-screen/icon/cy.png', sort: 1, type: 'system' }
                    
                    let obj2 = { name: "生物建模", url: '/atlas_view/', status: 0, icon: '/large-screen/icon/jm.png', sort: 2, type: 'system' }
                    let obj6 = { name: "企业官网", url: '/website_view/', status: 0, icon: '/large-screen/icon/gw.png', sort: 3, type: 'system' }
                        let obj3 = { name: "自定义", url: '', status: 0, icon: '', sort: 3, type: 'costom' }
                        let obj4 = { name: "自定义", url: '', status: 0, icon: '', sort: 4, type: 'costom' }
                        let obj5 = { name: "自定义", url: '', status: 0, icon: '', sort: 5, type: 'costom' }
                    if (res.data) {
                        
                        this.temp = res.data.temp
                        if (this.temp) {
                            if (this.temp.shouyeIcon) {
                                arr = JSON.parse(this.temp.shouyeIcon)
                            } else {
                                arr.push(obj1)
                                arr.push(obj7)
                                arr.push(obj2)
                                arr.push(obj6)
                                arr.push(obj3)
                                arr.push(obj4)
                                arr.push(obj5)
                            }

                        } else {
                            arr.push(obj1)
                            arr.push(obj7)
                            arr.push(obj2)
                            arr.push(obj6)
                            arr.push(obj3)
                            arr.push(obj4)
                            arr.push(obj5)
                        }
                    } else {
                        arr.push(obj1)
                        arr.push(obj7)
                        arr.push(obj2)
                        arr.push(obj6)
                        arr.push(obj3)
                        arr.push(obj4)
                        arr.push(obj5)
                        
                    }
                    this.tableData = this.sortKey(arr, 'sort')

                    console.log(this.tableData)
                }
            });
        }


    },
    async mounted() {
        // let result = await user.OrganizationbyUser()
        // if (result.resp_code == "10000") {
        //     this.organization = result.data;
        // }
        console.log(this.$route.params.id, "-----------")
        this.getTemp()



    }
};
</script>
    
<style lang="scss" scoped>
/* 推荐，实现简单 */



.aaa {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    -webkit-transition: opacity .3s;
    transition: opacity .3s;
    line-height: 100px;
}

.aaa:hover {
    opacity: 1;
}

.block {
    display: block;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
}

.top_0 {
    top: 0;
}

.left_0 {
    left: 0;
}

.right_0 {
    right: 0;
}

.absolute {
    position: absolute;
}

.iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.icon {
    display: flex;
    align-items: center;
    text-align: center;
    align-content: center;
    justify-content: center;

    span {
        display: block;
    }

    .icob {
        width: 36px;
        height: 36px;
        border: 2px solid #2CBA54;
        // background: #2CBA54;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            font-size: 24px;
        }
    }

    .icob-text {
        width: 87px;
        height: 27px;
        margin-left: 5px;
        line-height: 27px;
        color: #fff;
        font-size: 14px;
        text-align: center;
    }
}

/* 上传照片 */
.SeedlingsImg {
    .iconImage:hover {
        opacity: 1;
    }

    .seedlings-avatar-uploader {
        border: none !important;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .seedlings-avatar-uploader {
        border: 1px dashed #d9d9d9;
    }

    .seedlings-avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .seedlings-avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        line-height: 100px;
        text-align: center;
    }

    .icon-shibai {
        height: 18px;
        line-height: 18px;
    }
}

.projectManager {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-select-dropdown__list {
    padding: 20px 0;
}

.customWidth {
    width: 50%;
}
</style>

<style>
.zhoumian /deep/ .el-upload-list__item.is-ready,
.el-upload-list__item.is-uploading {
    display: none !important;
}

.hidden {
    display: none;
}
</style>
    